import { GOOGLE_API_KEY as GKey } from "../constants/AppConstants";

export const FONT_FAMILY = "Google Sans";

export const APP_NAME = "King Cabs";

export const GOOGLE_API_KEY = GKey;
